import { useEffect } from "react"

import { useBookingContext } from "modules/Booking/BookingContext"
import { Analytics } from "utils/analytics"
import { useService } from "modules/Booking/common/hooks"
import { DatePicker, Headline, OnlineOrOfflineTabs } from "modules/BookingCommon/components"
import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"
import { SESSION_TYPE } from "modules/Booking/common/constants"
import {
    NextPageButtonWithAdditionalInfoWithFooterMobile,
    NotAvailableSessionsText,
    PriceAndTime,
    RequestTime,
    SessionInfoCard,
} from "modules/Booking/SessionDatePage/components"

export function SessionDateTimePage() {
    const [
        { onlineOrOffline, psy, datePickerIsLoaded, currentWeek, selectedService, datePickerError },
        {
            setSlotId,
            changeSelectedTime,
            setDatePickerError,
            toggleDatePickerIsLoaded,
            setSlotDuration,
            setCurrentWeek,
            setSelectedDiscount,
            toggleTimeRequestModalActive,
            changeOnlineOrOffline,
            setIsChooseManuallyService,
            changeSessionType,
        },
    ] = useBookingContext()

    const { onlineService, offlineService, onlineAndOfflineAvailable } = useService()

    useEffect(() => {
        Analytics.booking_widget_shown({
            psy,
        })
        setSelectedDiscount(undefined)
        changeSessionType(SESSION_TYPE.DEFAULT)

        return () => {
            toggleTimeRequestModalActive(false)
        }
    }, [])

    return (
        <div className="redesign-container">
            <div className="session-date__container">
                <div className="session-date">
                    <Headline
                        onlineAndOfflineAvailable={onlineAndOfflineAvailable}
                        onlineOrOffline={onlineOrOffline}
                    />
                    <OnlineOrOfflineTabs
                        onlineService={onlineService}
                        offlineService={offlineService}
                        onlineOrOffline={onlineOrOffline}
                        isLoading={datePickerIsLoaded}
                        onChangeOnlineOrOffline={changeOnlineOrOffline}
                        onChangeChooseManuallyService={setIsChooseManuallyService}
                    />
                    <NotAvailableSessionsText />
                    <PriceAndTime isShowSessionDuration />
                    <DatePicker
                        psy={psy}
                        datePickerIsLoaded={datePickerIsLoaded}
                        currentWeek={currentWeek}
                        selectedService={selectedService}
                        initiator={INITIATOR.CLIENT}
                        onChangeSlotId={setSlotId}
                        onChangeSelectedTime={changeSelectedTime}
                        onChangeDatePickerErrorStatus={setDatePickerError}
                        onChangeDatePickerIsLoaded={toggleDatePickerIsLoaded}
                        onChangeSlotDuration={setSlotDuration}
                        onChangeCurrentWeek={setCurrentWeek}
                    />
                    {datePickerIsLoaded && psy.allow_time_request && (
                        <>
                            <hr className="mgt-3 mgb-3" />
                            <RequestTime />
                        </>
                    )}
                </div>
                <SessionInfoCard />
            </div>
            {datePickerError === undefined && datePickerIsLoaded && (
                <NextPageButtonWithAdditionalInfoWithFooterMobile />
            )}
        </div>
    )
}
